import alt from 'framework/alt';

class IdentityActions {
  constructor() {
    this.generateActions(
      'claimSucceeded',
      'claimFailed',
      'fetchSucceeded',
      'fetchFailed',
      'acknowledged',
      'confirmSucceeded',
      'confirmFailed',
    );
  }
}

export default alt.createActions(IdentityActions);
